import { TSVGProps } from '@/models/generics';

const ArrowWithColorIcon = (props: TSVGProps) => {
	return (
		<svg
			width='25'
			height='24'
			viewBox='0 0 25 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<rect
				y='0.000976562'
				width='24.0734'
				height='24'
				rx='12'
				fill={props?.fill ? props?.fill : '#76CDD6'}
			/>
			<path
				d='M8.52539 12.001H15.5468'
				stroke={props.strokeColor || 'white'}
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<path
				d='M12.0352 8.50098L15.5459 12.001L12.0352 15.501'
				stroke={props.strokeColor || 'white'}
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	);
};

export default ArrowWithColorIcon;
